
import {
  computed,
  defineExpose,
  defineComponent,
  onBeforeMount,
  onMounted,
  ref,
  toRaw,
  watch,
} from "vue";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { useStore } from "vuex";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import WidgetReportProcessing from "@/components/widgets/reports/WidgetReportProcessing.vue";
import { configure, Field, ErrorMessage, Form } from "vee-validate";
import MBloader from "@/components/MBLoader.vue";
import ConsentCheck from "@/components/ConsentCheck.vue";

import * as Yup from "yup";
import useLocale from "@/core/common/useLocale";

export default defineComponent({
  name: "widget-1",
  components: {
    Form,
    ErrorMessage,
    Field,
    MBloader,
    WidgetReportProcessing,
    ConsentCheck,
  },
  props: {
    vtbtab: Boolean,
    ctmstab: Boolean,
    widgetClasses: String,
    refWidgetReportProcessing: String,
  },
  inject: ["ismobile"],
  setup(props, { emit }) {
    const store = useStore();
    const { t, currentLocale } = useLocale();

    // const submitButton = ref<HTMLButtonElement | null>(null);
    let consent_status = ref(false);
    const isPatientValuesLoading = ref<boolean>(false);
    let ctmstab = ref(false);
    let vtbtab = ref(false);
    let patient_values = ref([]);
    const report_status_area = ref(false);
    const router = useRouter();
    const consent_status_temp = ref(false);
    const patient_s_email = ref("");
    const policy_content = ref("");
    const policy_check_list = ref<{ value: string; checked: boolean }[]>([]);
    const test_content = ref("Test 123");
    const inputField = ref(null) as any;
    const selectedConsent = ref<string>("");
    const consentchecker = Yup.object().shape({
      consent_checkbox: Yup.boolean()
        .required(t("This is a required field"))
        .label(t("This")),
    });

    const isCtmsTabActive = computed(() => {
      return router.currentRoute.value.name === "reports.ctms";
    });

    const handleConsentCheckChange = ({ index, value }) => {
      const consentToMutate = store.getters.getPolicyText;
      consentToMutate[selectedConsent.value].group[index].checked = value;
      store.commit(Mutations.POLICY_TEXT, consentToMutate);
    };

    const consentGroupChecked = computed(() => {
      const consentState = store.getters.getPolicyText;
      const avaiableModals = Object.keys(consentState);

      return !avaiableModals.some((modal) =>
        consentState[modal].group.some((content) => content.checked === false)
      );
    });

    const getText = async (type) => {
      const queryKey = type + "-html-" + currentLocale.value;
      selectedConsent.value = queryKey;

      if (
        Object.prototype.hasOwnProperty.call(
          store.getters.getPolicyText,
          queryKey
        )
      ) {
        return;
      }

      await store.dispatch(Actions.GET_POLICY_TEXT, queryKey);
    };

    const policyContent = computed(() => {
      return store.getters.getPolicyText[selectedConsent.value]?.other || "";
    });

    const policyCheckList = computed(() => {
      if (Object.keys(store.getters.getPolicyText).length > 0) {
        return store.getters.getPolicyText[selectedConsent.value]?.group || [];
      }
      return [];
    });

    const policyTitle = computed(() => {
      if (Object.keys(store.getters.getPolicyText).length > 0) {
        return store.getters.getPolicyText[selectedConsent.value]?.title || "";
      }

      return "";
    });

    const consentChange = (event) => {
      consent_status_temp.value = event.target.checked;
    };

    const process = store.getters.getPatientProcesses;
    ctmstab.value = process.ReleaseCTMSReportPatient ? true : false;
    vtbtab.value = process.ReleaseVTBReportPatient ? true : false;

    const getPatientValues = async () => {
      isPatientValuesLoading.value = false;
      const patientValues = store.getters.getPatientValues;

      patient_s_email.value = patientValues.patient_s_email;

      if (!patientValues.schedule_link) {
        const scheduleBaseUrl =
          "https://meetings.hubspot.com/massivebio/cancer-treatment-consultation";
        patientValues.schedule_link = `${scheduleBaseUrl}?email=${patientValues.patient_s_email}&firstname=${patientValues.first_name}&lastname=${patientValues.last_name}&phone=${patientValues.patient_s_phone}`;
      }

      patient_values.value = patientValues;

      if (patientValues.consent_sign == "1") {
        consent_status.value = true;
        report_status_area.value = false;
      }
      if (process.ReleaseCTMSReportPatient) {
        report_status_area.value = false;
      }
      if (ctmstab.value || vtbtab.value) {
        report_status_area.value = false;
      }


      isPatientValuesLoading.value = true;
    };

    const changeStatus = async () => {
      consent_status.value = true;
      await store.dispatch(Actions.UPDATE_PATIENT_VALUE, { consent_sign: 1 });

      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];
      if (!error) {
        Swal.fire({
          text: t("Thank you!"),
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: t("Close"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        }).then(() => {
          report_status_area.value = true;
        });
      } else {
        Swal.fire({
          text: t(error[0]),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("Try again!"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
    };

    const currentDateTime = computed(() => {
      return Intl.DateTimeFormat(
        currentLocale.value === "en" ? "en-us" : currentLocale.value
      ).format(new Date());
    });

    return {
      consentchecker,
      isCtmsTabActive,
      consent_status_temp,
      patient_values,
      getPatientValues,
      getIllustrationsPath,
      isPatientValuesLoading,
      changeStatus,
      consentChange,
      consent_status,
      report_status_area,
      patient_s_email,
      ErrorMessage,
      Field,
      ...useLocale(),
      currentDateTime,
      selectedConsent,
      policyTitle,
      policyContent,
      policyCheckList,
      test_content,
      handleConsentCheckChange,
      consentGroupChecked,
      inputField,
      getText,
    };
  },
});
